module.exports = __webpack_public_path__ + "media/B-A-005_SAF_BTB_Clicks.280a6947.mp4";